(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.onToggle = this.openSelector.bind(this);
      this.onFocusOut = this.closeSelector.bind(this);
      this.onKeyDown = this.onContainerKeyDown.bind(this);
      this.onSelect = this.onItemClick.bind(this);
      this.onOutsideClick = event => {
        if (!this.contains(event.target)) this.hidePanel();
      };
    }

    connectedCallback() {
      if (this.initialized) return;
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      if (!this.elements.input || !this.elements.button || !this.elements.panel) return;
      this.initialized = true;
      this.elements.button.addEventListener('click', this.onToggle);
      this.addEventListener('focusout', this.onFocusOut);
      this.addEventListener('keydown', this.onKeyDown);
      this.elements.panel.addEventListener('click', this.onSelect);
      document.addEventListener('click', this.onOutsideClick);
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.hidePanel();
      this.elements.button.removeEventListener('click', this.onToggle);
      this.removeEventListener('focusout', this.onFocusOut);
      this.removeEventListener('keydown', this.onKeyDown);
      this.elements.panel.removeEventListener('click', this.onSelect);
      document.removeEventListener('click', this.onOutsideClick);
      this.initialized = false;
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.hidden = true;
    }

    onContainerKeyDown(event) {
      if (event.key === 'Escape' && !this.elements.panel.hidden) {
        event.preventDefault();
        event.stopPropagation();
        this.hidePanel();
        this.elements.button.focus();
      } else if (event.key === 'ArrowDown' && event.target === this.elements.button) {
        event.preventDefault();
        this.elements.panel.hidden = false;
        this.elements.button.setAttribute('aria-expanded', 'true');
        const current = this.elements.panel.querySelector('[aria-current="true"]') || this.elements.panel.querySelector('a');
        if (current) current.focus();
      }
    }

    onItemClick(event) {
      const item = event.target.closest('a[data-value]');
      if (!item || !this.elements.panel.contains(item)) return;
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = item.dataset.value;
      this.hidePanel();
      if (form) {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.hidden = !this.elements.panel.hidden;
      this.elements.button.setAttribute('aria-expanded', String(!this.elements.panel.hidden));
    }

    closeSelector(event) {
      if (!event.relatedTarget || !this.contains(event.relatedTarget)) {
        this.hidePanel();
      }
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.desktopQuery = window.matchMedia('(min-width: 992px)');
      this.updateDesktopMenu = () => {
        const menu = this.querySelector('.header--top-center > .header__inline-menu');
        const active = this.desktopQuery.matches && !!menu;
        this.header.classList.toggle('canvoil-menu-sticky', active);
        if (active) {
          this.reset();
          const offset = menu.getBoundingClientRect().top - this.header.getBoundingClientRect().top;
          this.header.style.setProperty('--canvoil-menu-offset', `${Math.max(0, offset)}px`);
        } else {
          this.header.style.removeProperty('--canvoil-menu-offset');
        }
      };
      this.desktopQuery.addEventListener('change', this.updateDesktopMenu);
      this.menuResizeObserver = new ResizeObserver(this.updateDesktopMenu);
      this.menuResizeObserver.observe(this);
      this.updateDesktopMenu();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.desktopQuery?.removeEventListener('change', this.updateDesktopMenu);
      this.menuResizeObserver?.disconnect();
      this.header.classList.remove('canvoil-menu-sticky');
      this.header.style.removeProperty('--canvoil-menu-offset');
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.header.classList.contains('canvoil-menu-sticky')) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop >= 10) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader); 

  } catch(e) { console.error(e); }
})();
})();
